module.exports = function(ctx) {
var __t, __p = '';
__p += '<div class="formio builder row no-gutters formbuilder">\n  <div class="col-xs-5 col-sm-4 col-md-3 formcomponents">\n    ' +
((__t = (ctx.sidebar)) == null ? '' : __t) +
'\n  </div>\n  <div class="col-xs-7 col-sm-8 col-md-9 p-3 formarea" ref="form" role="form">\n    ' +
((__t = (ctx.form)) == null ? '' : __t) +
'\n  </div>\n</div>';
return __p
}